export default () => ({
	changeFreeShippingProgress() {
		setTimeout(() => {
			const progressIcon = this.$refs.progressIcon;
			const progressBar = this.$refs.activeProgress;
			const progressContainer = this.$refs.progressContainer;
			const progressPercent = +progressContainer.dataset.progress;

			progressIcon.style.left = `calc(${progressPercent}% - 17px)`;
			progressBar.style.width = `${progressPercent}%`;

			window.sessionStorage.setItem('previousShippingProgress', progressPercent);
		}, 300);
	},

	init() {
		this.changeFreeShippingProgress();
	},
});
